import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/FTP/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import FTPTable from 'components/Web_User_Interface/1440p_Series/Features/FTP/ftpTable';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Features/FTP/PrimaryBox';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Features Menü // Alarm FTP Upload",
  "path": "/Web_User_Interface/1440p_Serie/Features/FTP/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Um den Video-FTP-Upload zu verwenden, müssen Sie zunächst die Adresse Ihres FTP-Servers und Ihre Anmeldedaten festlegen. Sie können z. B. den FTP-Dienst Ihres Routers als FTP-Server verwenden - in diesem Fall geben Sie einfach die IP Ihres Routers als FTP-Server-Adresse ein. Wenn Sie einen FTP-Server auf einem lokalen PC einrichten (z. B. mit Filezilla Server), verwenden Sie die lokale IP-Adresse des PCs. Natürlich können Sie auch die URLs von Webservern verwenden. Der Standard-FTP-Port ist 21.",
  "image": "./WebUI_1440p_SearchThumb_Features_FTP.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_FTP.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title='Features Menü // Alarm FTP Upload' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Um den Video-FTP-Upload zu verwenden, müssen Sie zunächst die Adresse Ihres FTP-Servers und Ihre Anmeldedaten festlegen. Sie können z. B. den FTP-Dienst Ihres Routers als FTP-Server verwenden - in diesem Fall geben Sie einfach die IP Ihres Routers als FTP-Server-Adresse ein. Wenn Sie einen FTP-Server auf einem lokalen PC einrichten (z. B. mit Filezilla Server), verwenden Sie die lokale IP-Adresse des PCs. Natürlich können Sie auch die URLs von Webservern verwenden. Der Standard-FTP-Port ist 21.' image='/images/Search/WebUI_1440p_SearchThumb_Features_FTP.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Features_FTP.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Features/FTP/' locationFR='/fr/Web_User_Interface/1440p_Series/Features/FTP/' crumbLabel="Alarm FTP Upload" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/2e367/1440p_Settings_Features_FTP.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.21739130434783%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACVklEQVQoz12SS08TURhA+REuCCo0pm3sg1pAaelM59F3GabTO9OBtlAUMA1qMBqDFBoxYjSSGENcGRf+AmHhCmM0ceHOjdGdP+aYKakFFif33sU99yT3G4rFYkSjUaLj41z1+9CXthF7n5nb+YjZPaKwdfifYsc7H1HuHLK4/5V0fQtFShCJjjMyMoLP52MoHA7jEYlECPivkK0s0nzwitr6Lu6dp9TWB5grHYxbjym3HlFZ26HkrCElJRIJiYn4dSbiUwx5oj6BQBBNkWjOC+zKLNW5EsI8wa6U0eQEyalrJKZizEzHKWfzlLIOlrWEruaQJHVQGA57wgC6nqG5uMT8Qh2n5iJsp4ft1MgXiqiajqKoqLqOa7rcnl1lca5BqZAhLSsMhUKhXp0nPRHqNJtNHMfBtm2EED28vWVZmKZJuVzGMAyEabHbqvHsnsB2NGQpfSLsV54X9kX9NZfLoWkaipImnVYQVYM3+9u87DYwSylkSRkIvcpgMNi70Gg0cF33jOx8rVe53dnk76+fHB/sUS0qyJJ8IvTG5nThzeVl6vWFcxKHfKHQe1BTVaZvTNPtbPL7+zd+vH/HXbtEciZ1ttATqpqGcBsYloNVFQNhtYKuSCiKTDqbJZ5Msnl/gz9fPnH84S3PVw2yunL6l8P4/QHyWZ3uustOW9CqO9g1F7fm4LbaiJWH1BurbJgVNiyBMAxKmkIxlSAZDxONhE7PYRi/N4dyktdtlYO2jGvoqJkcuYxGvtam2H6BcNp0UzJPtBwzk5NcGB7m4uVRLo2OMTo2xj+V6Zue77P+ugAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b7488abcae69bf1a1b1c0f5f722ab858/e4706/1440p_Settings_Features_FTP.avif 230w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/d1af7/1440p_Settings_Features_FTP.avif 460w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/7f308/1440p_Settings_Features_FTP.avif 920w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/730d0/1440p_Settings_Features_FTP.avif 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/b7488abcae69bf1a1b1c0f5f722ab858/a0b58/1440p_Settings_Features_FTP.webp 230w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/bc10c/1440p_Settings_Features_FTP.webp 460w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/966d8/1440p_Settings_Features_FTP.webp 920w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/fbb05/1440p_Settings_Features_FTP.webp 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/b7488abcae69bf1a1b1c0f5f722ab858/81c8e/1440p_Settings_Features_FTP.png 230w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/08a84/1440p_Settings_Features_FTP.png 460w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/c0255/1440p_Settings_Features_FTP.png 920w", "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/2e367/1440p_Settings_Features_FTP.png 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/b7488abcae69bf1a1b1c0f5f722ab858/c0255/1440p_Settings_Features_FTP.png",
              "alt": "Web User Interface - 1440p Series - Features FTP",
              "title": "Web User Interface - 1440p Series - Features FTP",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <FTPTable mdxType="FTPTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "ftp-server-upload",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#ftp-server-upload",
        "aria-label": "ftp server upload permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`FTP Server Upload`}</h3>
    <p>{`Um Bilder oder Videos im Alarmfall auf Ihren FTP Server zu laden, müssen Sie hier erst einmal Ihre Benutzer Daten für den FTP Server hinterlegen. Der FTP Server kann dabei z.B. Ihr Router sein - in diesem Fall brauchen Sie als Server Adresse einfach die IP Adresse Ihres Routers (z.B. 192.168.178.1) hinterlegen. Alternativ können Sie auch einen FTP Server auf einem Rechner in Ihrem lokalen Netzwerk aufsetzen - Programme wie Filezilla Server machen es Ihnen einfach. In diesem Fall wäre die Server Adresse gleich der lokalen IP des Rechners, auf dem Sie den Filezilla Server installiert haben. Alternativ können Sie natürlich auch einen FTP Dienst im Internet nutzen, indem Sie die Webadresse (URL) hier eingeben. Der `}<strong parentName="p">{`Standard Port`}</strong>{` für die FTP Dateiübertragung ist die `}<strong parentName="p">{`21`}</strong>{`.`}</p>
    <p>{`Unter FTP Ordner können Sie ein Upload-Verzeichnis auf dem FTP-Server festlegen. Der Root-Ordner eines FTP-Servers kann über `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`./`}</code>{` erreicht werden. Die Trennung zwischen einzelnen Ordnern funktioniert mit einem `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/`}</code>{`. Ein Unterordner (z.B. INSTAR) kann mit `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`./INSTAR`}</code>{` erreicht werden. Ein `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/`}</code>{` am Ende ist nicht notwendig, kann aber verwendet werden.`}</p>
    <p>{`Der FTP Benutzername und das FTP Passwort sind die Login-Daten für Ihren FTP-Account.`}</p>
    <p>{`Der Dateiname des Videos ist fix und besitzt die folgende Syntax: Präfix (`}<strong parentName="p">{`A, P, N oder T`}</strong>{`) + `}<strong parentName="p">{`YYMMDD_hhmmss_hhmmss.avi`}</strong>{`. Das Präfix signalisiert den Auslöser der Aufnahme (s.u.). Getrennt durch einen Unterstrich folgen dann die Start- und Endzeit der Aufnahme.`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <PrimaryBox mdxType="PrimaryBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "passiv-oder-port",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#passiv-oder-port",
        "aria-label": "passiv oder port permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Passiv oder Port`}</h3>
    <p>{`Beim FTP Modus können Sie zwischen dem passiven (`}<strong parentName="p">{`PASV`}</strong>{`) und einem aktiven (`}<strong parentName="p">{`PORT`}</strong>{`) wählen. Der Standard Modus ist der PASV Modus. Wenn Ihr Server jedoch extern hinter einem Router mit einer NAT Firewall steht, müssen Sie den PORT Modus wählen.`}</p>
    <h3 {...{
      "id": "verwenden-sie-ihren-router-oder-ihr-nas-laufwerk-als-ftp-server",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#verwenden-sie-ihren-router-oder-ihr-nas-laufwerk-als-ftp-server",
        "aria-label": "verwenden sie ihren router oder ihr nas laufwerk als ftp server permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Verwenden Sie Ihren Router oder Ihr NAS-Laufwerk als FTP-Server`}</h3>
    <p>{`Die meisten modernen Router unterstützen jetzt USB-Massenspeichergeräte (USB-Sticks, Festplatten, ...), die angeschlossen werden können - manche sogar mit einer großen Menge an integriertem Speicher, um einen Network-Attached-Storage (NAS) zu verwenden . Diese Speicherplätze können von FTP-Clients wie Ihrer INSTAR IP-Kamera beschrieben werden. Alles, was Sie tun müssen, ist, den Speicher bereitzustellen und einen FTP-Benutzer in Ihrem Router einzurichten, und die Kamera kann Schnappschüsse oder sogar ganze Alarmvideos an den Server senden. Das folgende Video zeigt den Setup-Vorgang für eine AVM Fritzbox - aber Sie finden `}<a parentName="p" {...{
        "href": "/de/Bewegungserkennung/Router_als_FTP_Server/"
      }}>{`weitere Beispiele hier`}</a>{`.`}</p>
    <h3 {...{
      "id": "einrichten-eines-ftp-servers-auf-ihrem-windows-computer",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#einrichten-eines-ftp-servers-auf-ihrem-windows-computer",
        "aria-label": "einrichten eines ftp servers auf ihrem windows computer permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Einrichten eines FTP-Servers auf Ihrem Windows-Computer`}</h3>
    <p>{`Ihre Kamera kann Bilder während eines Alarmereignisses hochladen oder Sie können auch Bilder in einem definierten Zeitraum auf einen beliebigen FTP-Server hochladen. Neben Online-Angeboten für FTP-Server oder Router, die als FTP-Server fungieren können, können Sie auch Ihren lokalen Computer oder Server so einrichten, dass er als FTP-Server fungiert, um Bilder von der Kamera zu empfangen - `}<a parentName="p" {...{
        "href": "/de/Bewegungserkennung/FTP_Server_Setup/"
      }}>{`lesen Sie hier mehr`}</a>{`.`}</p>
    <h2 {...{
      "id": "verschlüsselung-und-host-verifizierung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#verschl%C3%BCsselung-und-host-verifizierung",
        "aria-label": "verschlüsselung und host verifizierung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Verschlüsselung und Host Verifizierung`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/Frequently_Asked_Question/Using_the_sFTP_Service_with_your_WQHD_Camera/"
        }}>{`FAQs :: Nutzen des sFTP Dienstes mit Ihrer 2k+ (WQHD) Kamera`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      